import React, { useEffect, useMemo } from 'react'
import { getCookiesByPrefix } from 'services/cookies'

interface TintimLinkProps extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
  url: string
  onClick?: () => unknown
  children?: React.ReactNode
}

export const TintimLink = ({ url, onClick, children, ...props }: TintimLinkProps) => {
  const urlWithParameters = useMemo(() => {
    const finalUrl = new URL(url)
    finalUrl.search = new URL(window.location.href).search

    const trackingCookies = getCookiesByPrefix('tt_')

    for (const [key, value] of Object.entries(trackingCookies)) {
      if (!finalUrl.searchParams.has(key)) {
        finalUrl.searchParams.append(key, value)
      }
    }

    return finalUrl.toString()
  }, [url])

  return (
    <a href={urlWithParameters} onClick={onClick} {...props}>
      {children}
    </a>
  )
}
